import {invokeApig} from "../../libs/awsLib";
import {getUserApiData} from "../../utils/UserUtils";
import Paths from "../paths";

export function getQueryResults(
    {
        ToTempFilesRowsThreshold = 10000,
        TablesNameConversion = true,
        PreLoadParamsDataset = false,
        ForcePreLoadParamsDataset = false,
        Queries,
        ForceTempTable = false,
    },
    {FarmID, ClientID, LocalUserID} = {}
) {
    const {_FarmID, _LocalUserID, _ClientID} = getUserApiData({
        FarmID,
        ClientID,
        LocalUserID,
    });
    return invokeApig({
        ...Paths.getQueryResults({
            farmID: _FarmID,
            clientID: _ClientID,
            localUserID: _LocalUserID,
        }),
        body: {
            ToTempFilesRowsThreshold,
            TablesNameConversion,
            PreLoadParamsDataset,
            ForcePreLoadParamsDataset,
            Queries,
            ForceTempTable,
        },
    });
}
